import * as React from 'react';
import { SxProps, Theme } from '@mui/material';
import { Confirm } from 'react-admin';
import { useFormikContext } from 'formik';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BackButton } from './BackButton';

interface FormBackButtonProps {
  sx?: SxProps<Theme>;
}

/**
 * Przycisk "wroc" dla ekranow create/edit. Musi stac WEWNATRZ drzewa Formika,
 * bo pyta go o `dirty`.
 *
 * Ostrzega tylko wtedy, gdy formularz faktycznie zostal zmieniony. Ostrzeganie
 * za kazdym wyjsciem uczy klikac "wyjdz" odruchowo i wtedy modal przestaje
 * chronic cokolwiek — a samo zajrzenie w rekord nie jest niebezpieczna operacja.
 */
export const FormBackButton: React.FC<FormBackButtonProps> = ({ sx }) => {
  const { dirty } = useFormikContext();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [confirmOpen, setConfirmOpen] = React.useState(false);

  return (
    <>
      <BackButton sx={sx} onClick={() => (dirty ? setConfirmOpen(true) : navigate(-1))} />
      <Confirm
        isOpen={confirmOpen}
        title={t('common.unsavedChanges.title')}
        content={t('common.unsavedChanges.body')}
        confirm={t('common.unsavedChanges.confirm')}
        cancel={t('common.cancel')}
        onConfirm={() => {
          setConfirmOpen(false);
          navigate(-1);
        }}
        onClose={() => setConfirmOpen(false)}
      />
    </>
  );
};

export default FormBackButton;
